import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

// Material UI components
import {
  Container,
  Typography,
  Button,
  Paper} from '@mui/material';

// Material UI icons
import {
  SentimentDissatisfied as SadIcon,
  Home as HomeIcon
} from '@mui/icons-material';

const NotFound = () => {
  
  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 5, 
          borderRadius: 3,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <SadIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
        
        <Typography 
          variant="h1" 
          component="h1" 
          sx={{ 
            fontSize: { xs: '6rem', md: '8rem' },
            fontWeight: 700,
            color: 'primary.main',
            mb: 2
          }}
        >
          404
        </Typography>
        
        <Typography 
          variant="h4" 
          component="h2" 
          gutterBottom
          sx={{ mb: 3 }}
        >
          Page Not Found
        </Typography>
        
        <Typography 
          variant="body1" 
          color="text.secondary" 
          sx={{ 
            maxWidth: 500,
            mb: 4,
            fontSize: '1.1rem'
          }}
        >
          The page you are looking for might have been removed, had its name changed,
          or is temporarily unavailable.
        </Typography>
        
        <Button 
          component={RouterLink} 
          to="/" 
          variant="contained" 
          size="large"
          startIcon={<HomeIcon />}
          sx={{ 
            px: 4, 
            py: 1.5,
            borderRadius: 2,
            fontSize: '1rem'
          }}
        >
          Go to Dashboard
        </Button>
      </Paper>
    </Container>
  );
};

export default NotFound;
